export const clearSession = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("station");
    localStorage.removeItem("stationId");
    localStorage.removeItem("refreshToken");
};

export const logout = (navigate: (path: string) => void) => {
    clearSession();
    navigate("/login");
};

export const persistToken = (token: string) => {
    localStorage.setItem("authToken", token);
};

export const persistRefreshToken = (refreshToken: string) => {
    localStorage.setItem("refreshToken", refreshToken);
};

export const persistStation = (station: string) => {
    localStorage.setItem("station", station);
};

export const persistStationId = (stationId: string) => {
    localStorage.setItem("stationId", stationId);
};

export const getToken = () => localStorage.getItem("authToken");

export const getRefreshToken = () => localStorage.getItem("refreshToken");

export const getStationCode = () => localStorage.getItem("station");

export const getStationId = () => localStorage.getItem("stationId");
